export default __webpack_public_path__ + "static/media/p3-18.ed1f6f85.png";